import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import CollaborationBanner from '../components/CollaborationBanner';
import Statistics from '../components/Statistics';
import Program from '../components/Program';
import Investment from '../components/Investment';
import Benefits from '../components/Benefits';
import CareerPathway from '../components/CareerPathway';
import Eligibility from '../components/Eligibility';
import Application from '../components/Application';
import Disclaimer from '../components/Disclaimer';
import Footer from '../components/Footer';
import SuccessModal from '../components/SuccessModal';

function Home() {
  const [showModal, setShowModal] = useState(false);

  const handleFormSubmit = (formData) => {
    console.log('Form submitted:', formData);
    setShowModal(true);
    
    // In production, send to your API
    // fetch('/api/submit', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(formData)
    // });
  };

  return (
    <>
      <Header />
      <Hero />
      <Statistics />
      <Program />
      <Investment />
      <Benefits />
      <CareerPathway />
      <Eligibility />
      <Application onSubmit={handleFormSubmit} />
      <Disclaimer />
      <CollaborationBanner />
      <Footer />
      <SuccessModal show={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}

export default Home;
